import React from "react";
import { Helmet } from "react-helmet";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_Receipt } from "@templates/Receipt";
import { useParams } from "react-router-dom";

const DA_ReceiptPage = () => {
    const { orderId, orderSecret } = useParams();
    const { globalTranslations, getDictionaryString } = useTranslations();

    return (
        <>
            <Helmet>
                <title>
                    {getDictionaryString("Receipt")}
                    {" | "}
                    {globalTranslations.pageTitlePostfix}
                </title>
            </Helmet>

            <DA_Receipt basketId={orderId} basketSecret={orderSecret} />
        </>
    );
};

export default DA_ReceiptPage;
